import { createFileRoute } from "@tanstack/react-router";
import { SEO } from "@/features/marketing/seo";
import { CountdownTool } from "@/features/marketing/tools/countdown-tool";

export const Route = createFileRoute("/_marketing/wedding-countdown")({
  head: SEO.countdown,
  component: CountdownTool,
});
